import Minze, { Attrs, EventListeners, MinzeAttrs, MinzeElement, Reactive } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { Font } from '../../constants'
import { getFromSessionCache, storeInSessionCache } from '../../modules/cache'

Locale.getInstance().registerKeySet('fr', 'lvcDiscovery', {
  next: 'Suivant',
  previous: 'Précédent',
  register: "M'inscrire",
  login: 'Me connecter',
})

Locale.getInstance().registerKeySet('en', 'lvcDiscovery', {
  next: 'Next',
  previous: 'Previous',
  register: 'Sign up',
  login: 'Sign in',
})

const SCREENS = ['when', 'where', 'kind', 'results']
export class LvcDiscovery extends MinzeElement {
  attrs: Attrs = [['data-embedded-mode', false]]

  private isLoggedIn: boolean = false
  private screen: number = 0
  private whereValue: string = ''
  private whenValue: string = ''
  private kindValue: string = ''

  async onReady(): Promise<void> {
    let storageObject = getFromSessionCache('lvc-discovery', true)

    if (storageObject) {
      this.screen = storageObject.screen
      this.whereValue = storageObject.whereValue
      this.whenValue = storageObject.whenValue
      this.kindValue = storageObject.kindValue
    }

    this.isLoggedIn = MainModule.getInstance().getAuth().isLoggedIn()
    MainModule.getInstance()
      .getEE()
      .on('lvc:user_state_changed', () => {
        this.isLoggedIn = MainModule.getInstance().getAuth().isLoggedIn()
        this.rerender()
      })

    this.rerender()
  }

  async onLogin(): Promise<void> {
    let storageObject = {
      screen: this.screen,
      whereValue: this.whereValue,
      whenValue: this.whenValue,
      kindValue: this.kindValue,
    }
    storeInSessionCache('lvc-discovery', storageObject, 60 * 5 * 1000)
    MainModule.getInstance()
      .getRouting()
      .goTo(MainModule.getInstance().getRouting().getRoute('login'))
  }

  async onRegister(): Promise<void> {
    let storageObject = {
      screen: this.screen,
      whereValue: this.whereValue,
      whenValue: this.whenValue,
      kindValue: this.kindValue,
    }
    storeInSessionCache('lvc-discovery', storageObject, 60 * 5 * 1000)
    MainModule.getInstance()
      .getRouting()
      .goTo(MainModule.getInstance().getRouting().getRoute('signup'))
  }

  async onNext(): Promise<void> {
    if (SCREENS[this.screen] === 'where') {
      this.whereValue = this.select('lvc-discovery-place')?.getAttribute('selected') ?? ''
    }
    if (SCREENS[this.screen] === 'when') {
      this.whenValue = this.select('lvc-discovery-time')?.getAttribute('selected') ?? ''
    }
    if (SCREENS[this.screen] === 'kind') {
      this.kindValue = this.select('lvc-discovery-kind')?.getAttribute('selected') ?? ''
    }

    if (this.screen < SCREENS.length - 1) {
      if (SCREENS[this.screen + 1] === 'results' && this.dataEmbeddedMode) {
        let storageObject = {
          screen: this.screen + 1,
          whereValue: this.whereValue,
          whenValue: this.whenValue,
          kindValue: this.kindValue,
        }
        storeInSessionCache('lvc-discovery', storageObject, 60 * 5 * 1000)
        MainModule.getInstance()
          .getRouting()
          .goTo(MainModule.getInstance().getRouting().getRoute('discovery'), true)
      } else {
        this.screen++
      }
      this.rerender(true)
    }
  }

  async onPrevious(): Promise<void> {
    if (this.screen > 0) {
      this.screen--
      this.rerender(true)
    }
  }

  renderPaywall() {
    return `
      <lvc-discovery-paywall>
        <div class="col">
          <lvc-button enable-hover-box-shadow="true" theme="primary" name="login" font-weight=${Font.weight.medium}>${Locale.getKey('lvcDiscovery.login')}</lvc-button>
          <lvc-button enable-hover-box-shadow="true" theme="primary" name="register" font-weight=${Font.weight.medium}>${Locale.getKey('lvcDiscovery.register')}</lvc-button>
        </div>
      </lvc-discovery-paywall>
    `
  }

  renderProgressButtons() {
    let previousButton = ''
    if (this.screen > 0) {
      previousButton = `
      <lvc-button enable-hover-box-shadow="true" theme="secondary" name="previous" font-weight=${Font.weight.medium} display="flex" align-items="center">

            <lvc-discovery-arrow-left-icon class="arrow-left"></lvc-discovery-arrow-left-icon>
            ${Locale.getKey('lvcDiscovery.previous')}

          </lvc-button>`
    }
    return `
      <div class="row">
        ${previousButton}
        <lvc-button enable-hover-box-shadow="true" theme="primary" name="next" font-weight=${Font.weight.medium} width="fit-content" display="flex" align-items="center">

            ${Locale.getKey('lvcDiscovery.next')}


            <lvc-discovery-arrow-right-icon class="arrow-right"></lvc-discovery-arrow-right-icon>

        </lvc-button>
      </div>
    `
  }

  renderResults() {
    if (MainModule.getInstance().getAuth().isLoggedIn()) {
      return `<lvc-discovery-results where-value="${this.whereValue}" when-value="${this.whenValue}" kind-value="${this.kindValue}"></lvc-discovery-results>`
    }

    return this.renderPaywall()
  }

  renderScreen() {
    const totalScreens = SCREENS.length
    const currentScreen = this.screen + 1
    const stepText = `${currentScreen}/${totalScreens}`

    switch (SCREENS[this.screen]) {
      case 'when':
        return `
        <h5 class="step">${stepText}</h5>
          <lvc-discovery-time></lvc-discovery-time>
          ${this.renderProgressButtons()}
        `
      case 'where':
        return `
        <h5 class="step">${stepText}</h5>
          <lvc-discovery-place></lvc-discovery-place>
          ${this.renderProgressButtons()}
        `
      case 'kind':
        return `
        <h5 class="step">${stepText}</h5>
          <lvc-discovery-kind></lvc-discovery-kind>
          ${this.renderProgressButtons()}
        `
      case 'results':
        return this.renderResults()
    }

    return ''
  }

  html = () => `
    <div class="container">
      ${this.renderScreen()}
    </div>
     
  `

  css = () => `
    :host {
      color: var(--brand-minuit, #1E007D);
      font-family: ${Font.family};
      width: 100%;
      margin: 0 auto;
      ${this.dataEmbeddedMode ? 'min-height: 500px;' : 'min-height: calc(100vh - 140px);'}
    }
    .container {
      width: 100%;
    }
    .step {
      font-family: ${Font.family};
      color: var(--brand-minuit, #1E007D);
      text-align: center;
      font-size: 15px;
      font-weight: ${Font.weight.bold};
      margin: 0 0 16px;
    }
    .row {
      display: flex;
      flex-direction: row;
      justify-content:center;
      gap: 10px;
    }
    .col {
      max-width: 200px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .next-button-text, previous-button-text {
      line-height: 25px;
    }

    .next-button-text lvc-slider-arrow-right-icon, lvc-slider-arrow-left-icon {
      display: inline-block;
      vertical-align: middle;
    }
    
    .arrow-right{
      margin-left: 10px;
    }

    .arrow-left{
      margin-right: 10px;
    }
  `

  eventListeners: EventListeners = [
    ['lvc-button[name="login"]', 'click', this.onLogin.bind(this)],
    ['lvc-button[name="register"]', 'click', this.onRegister.bind(this)],
    ['lvc-button[name="next"]', 'click', this.onNext.bind(this)],
    ['lvc-button[name="previous"]', 'click', this.onPrevious.bind(this)],
  ]
}
